export default "__VITE_ASSET__DHmiCymx__"